import { Capacitor } from '@capacitor/core';
import { createClient } from '@supabase/supabase-js';

// Check for required environment variables. Public pages such as /help must
// still render when these are absent, so the client falls back to a
// non-routable URL instead of throwing during module init.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

const nativeApp = typeof window !== 'undefined' && Capacitor.isNativePlatform();

export const supabase = createClient(
  supabaseUrl || 'https://localhost.invalid',
  supabaseAnonKey || 'missing-anon-key',
  {
    auth: {
      // The website keeps the implicit flow it already uses. The native shell
      // uses a code on the custom scheme, because Android can drop a URL hash.
      flowType: nativeApp ? 'pkce' : 'implicit',
      detectSessionInUrl: true,
      persistSession: true,
    },
  },
);